export { default } from '../de/faq-shipping';



// WEBPACK FOOTER //
// ./src/components/async/deShipping.js